import { md5Hex } from './md5'

/** 平台密码密钥（等同服务端 conf/app.ini 的 app.ConsoleKey） */
export const PWD_SECRET = 'HWBaseSt@26077'

/**
 * 登录密码哈希：md5(PwdSecret + 明文密码) 的小写 hex
 * 用于 /Admin/Login 的 password_md5 字段
 */
export function passwordToMd5(plain) {
  return md5Hex(PWD_SECRET + String(plain == null ? '' : plain))
}
